/** Verify if a user is logged in to Creek */
const fetch = require('../helpers/fetch');
const ADMIN_TEST_URL = 'https://admin.bff.fm/admin/settings';

function checkAuth() {
  fetch.head(ADMIN_TEST_URL, { withCredentials: true }, {
    success: function receiveSettingsResponse(_, xhr) {
      if (xhr.status === 200) {
        document.body.className += ' u-isLoggedIn';
      }
    }
  });
}

module.exports = checkAuth;



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/auth.js
// module id = 44
// module chunks = 0